<script setup lang="ts">
  import { testIds, type StakeholderType } from '@gat-ship/types'
  import { IconOrganization, IconPlus } from '@gat-ship/icons'
  import { useContactProvider } from '../../../../composables/useStakeholderContacts'
  import { Button, DropdownMenuItem } from '@gat-ship/vue-components'

  const props = withDefaults(
    defineProps<{
      as?: 'button' | 'empty-state'
      label?: string
      stakeholderId: string
      stakeholderName: string
      stakeholderShortName: string
      stakeholderType: StakeholderType
    }>(),
    {
      as: 'button',
      label: 'Add Contact Point'
    }
  )

  const { modals } = useContactProvider()
</script>

<template>
  <DropdownMenuItem
    v-if="props.as === 'button'"
    :data-testid="testIds.stakeholders.contacts.actions.addContactPoint"
    @click="
      modals.showAddContactModal({
        stakeholderId: props.stakeholderId,
        stakeholderName: props.stakeholderName,
        stakeholderShortName: props.stakeholderShortName,
        stakeholderType: props.stakeholderType,
        contactType: 'other'
      })
    "
  >
    <IconPlus class="size-4" />
    {{ label }}
  </DropdownMenuItem>
  <Button
    v-else-if="props.as === 'empty-state'"
    variant="outline"
    @click="
      modals.showAddContactModal({
        stakeholderId: props.stakeholderId,
        stakeholderName: props.stakeholderName,
        stakeholderShortName: props.stakeholderShortName,
        stakeholderType: props.stakeholderType,
        contactType: 'other'
      })
    "
  >
    <IconOrganization class="size-4" />
    Add Contact Point
  </Button>
</template>
